<template>
  <header class="header-global">
    <base-nav :class="' navbar-main '+ navbarClass" type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="img/brand/white.png" />
      </router-link>

      <div class="row" slot="content-header">
        <div class="col-6 collapse-brand img-shadow">
          <router-link to="/">
            <img src="img/brand/white.png" />
          </router-link>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
        <!-- <router-link to="/" class="navigation-button"><i class="fa fa-home"></i></router-link> -->
        <base-dropdown tag="li" class="nav-item">
          <router-link
            slot="title"
            to="/nosotros"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text">Nosotros</span>
          </router-link>
          <router-link to="/nosotros" class="dropdown-item">Nosotros</router-link>
          <router-link to="/donde-estamos" class="dropdown-item">¿Dónde estamos?</router-link>
          
          
          
      
        </base-dropdown>
        <base-dropdown tag="li" class="nav-item">
          <router-link
            slot="title"
            to="/productos"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text">Productos</span>
          </router-link>
          <router-link to="/productos" class="dropdown-item">Productos</router-link>
          <router-link to="/notin" class="dropdown-item">NOTIN</router-link>
          <router-link to="/kubo" class="dropdown-item">Kubo</router-link>
          <router-link to="/nexus" class="dropdown-item">Nexus</router-link>
          <router-link to="/notariavirtual" class="dropdown-item">Notaría Virtual</router-link>
          <router-link to="/pagina-web" class="dropdown-item">Página Web</router-link>
        </base-dropdown>
        <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text">Novedades</span>
          </a>
          <!-- <router-link to="/portalcliente" class="dropdown-item">Portal del Cliente</router-link> -->
          <router-link to="/notariavirtual" class="dropdown-item">Notaría Virtual</router-link>
          <router-link to="/hash" class="dropdown-item">Hash Notarial</router-link>
          <router-link to="/moratorias" class="dropdown-item">Moratorias con <span class="makina">maKina</span></router-link>
          <a href="https://banner.notin.es/Landings/parser/" class="dropdown-item">Parser</a>
          <router-link to="/pagina-web" class="dropdown-item">Página Web</router-link>
        </base-dropdown>
        <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="https://notin.es/portal"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text">Blog</span>
          </a>
          <a href="https://notin.es/blog/" class="dropdown-item">Articulos</a>
          <a href="https://notin.es/notarios-en-la-red/" class="dropdown-item">Noticias</a>
          <a href="https://notin.freshteam.com/jobs" class="dropdown-item">Empleos</a>
          <a href="https://aula.notin.es?utm_medium=notin-web&utm_medium=header-phone" class="dropdown-item">Aula</a>
        </base-dropdown>
        <a href="https://notin.freshteam.com/jobs" class="nav-link" slot="title" target="_blank">Empleos</a>
        <a href="https://aula.notin.es?utm_medium=notin-web&utm_medium=header-escritorio" class="nav-link" slot="title" target="_blank">Aula</a>
        <!-- <li tag="li" class="nav-item">
          <router-link
            slot="title"
            href="/academy"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <span class="nav-link-inner--text">Academy</span>
          </router-link>

      
        </li> -->
        <li class="btn btn-secondary btn-sm" v-scroll-to="'#contacto'"> Solicitar una llamada <i class="fa fa-phone"></i></li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="https://www.facebook.com/DNotin" target="_blank">
            <i class="fa fa-facebook-square"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="https://twitter.com/Notin_es" target="_blank">
            <i class="fa fa-twitter"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="https://www.linkedin.com/company/notin.net" target="_blank">
            <i class="fa fa-linkedin"></i>
          </a>
        </li>
      </ul>
      <!-- <ul v-if="user" class="navbar-nav align-items-lg-center ml-lg-auto">
        <base-dropdown tag="li" class="nav-item">
          <li class="nav-item d-none d-lg-block ml-lg-4">
            <router-link to="/" class="nav-link"
              >{{ user.name }} {{ user.surname }}</router-link
            >
          </li>
          <li class="nav-item d-none d-lg-block ml-lg-4">
            <a href="#" @click="logout($event)" class="nav-link">Logout</a>
          </li>
        </base-dropdown>
      </ul> 
      <ul v-else class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item d-none d-lg-block ml-lg-4">
          <router-link to="/login" class="nav-link">Login</router-link>
        </li>
        <li class="nav-item d-none d-lg-block ml-lg-4">
          <router-link to="/register" class="nav-link">Register</router-link>
        </li>
      </ul> -->
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import Cookies from "../utils/Cookies";
import jwtDecode from "jwt-decode";

export default {
  name:"AppHeader",
  components: {
    BaseNav,
    BaseDropdown
  },
  data(){
    return {
      
    }
  },
  computed: {
    user: function() {
      return this.$store.state.user;
    },
    navbarClass(){
      return this.scroll > 20 ? " navbar-sticky" : " navbar-transparent "
    }
  },
  created() {
    const token = Cookies.read("token");

    if (token) {
      const user = jwtDecode(token);
      this.$store.dispatch("LOGIN", user);
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    
    logout(e) {
      e.preventDefault();

      /* First we remove the token in order to stop logging the user on app start-up */
      console.log(Cookies.remove("token"));

      /* Then we clear the user object from our store */
      return this.$store.dispatch("LOGOUT");
    }
  }
};
</script>
<style></style>
